/* eslint-disable */
import { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import NotFoundPage from './pages/notFoundPage/NotFoundPage';
import PrivateRoute from './pages/startPage/privateRoute/PrivateRoute';
import StartPage from './pages/startPage/StartPage';
import StartManyPage from './pages/startManyPage/StartManyPage';
import ChargingPage from './pages/chargingPage/ChargingPage';
import ContactsPage from './pages/contactsPage/ContactsPage';
import TermsPage from './pages/termsPage/TermsPage';
import B2BTermsPage from './pages/b2bTermsPage/B2BTermsPage';
import InstallAppPage from './pages/installAppPage/InstallAppPage';
import OpenAppPage from './pages/openAppPage/OpenAppPage';
import ReactGA from 'react-ga';
import B2bPage from './pages/b2bPage/B2bPage';
import B2BTariffsPage from './pages/b2bTariffsPage/B2BTariffsPage';
import RedirectLogin from './pages/b2bPage/redirectLogin/RedirectLogin';
import { ENV } from './environment';
import StationNumberLayout from './components/layouts/stationNumberLayout/StationNumberLayout';
import StartManyLayout from './components/layouts/startManyLayout/StartManyLayout';
import HistoryPage from './pages/historyPage/historyPage';
import ScannerPage from './pages/scannerPage/ScannerPage';
import StartErrorPage from './pages/startErrorPage/startErrorPage';
import TokaRedirectPage from './pages/tokaRedirectPage/TokaRedirectPage';
import HomeMapPage from './pages/homePage/HomeMapPage';
import HomeListPage from './pages/homePage/HomeListPage';
import { clarity } from 'react-microsoft-clarity';
import React, { useEffect, useState } from 'react';
import BackendConnectionGuard from './components/BackendConnectionGuard';
import PortraitOnlyGate from './components/PortraitOnlyGate';
import { startEvDriverTracker } from './hookServices/evDriverTracker';

const TRACKING_ID = 'UA-246535650-1';

if (ENV === 'prod') {
  ReactGA.initialize(TRACKING_ID);
  clarity.init('opcn7h9p5n');
}

function App() {
  // When app is opened via deep link (e.g. km220://charging?station=139), navigate WebView to the same path on 220-km.com
  useEffect(() => {
    let removeListener;
    try {
      const Capacitor = window.Capacitor;
      const App = Capacitor?.Plugins?.App;
      if (!App?.addListener) return;

      const handler = event => {
        try {
          const url = event?.url;
          // Support both km220:// (current) and 220km:// (legacy) so deep links keep working
          if (!url || (!url.startsWith('km220://') && !url.startsWith('220km://'))) return;
          const u = new URL(url);
          const path = u.hostname ? `/${u.hostname}${u.pathname || ''}` : u.pathname || '/charging';
          const target = `https://220-km.com${path}${u.search || ''}`;
          window.location.href = target;
        } catch (_) {
          // ignore parse errors
        }
      };

      const result = App.addListener('appUrlOpen', handler);
      // Capacitor can return Promise<{remove}> or {remove} directly; never call .then on result
      // without resolving first so we don't throw "then is not a function" if bridge returns a plain object
      Promise.resolve(result)
        .then(r => {
          if (r?.remove && typeof r.remove === 'function') removeListener = r.remove;
        })
        .catch(() => {});
      if (removeListener) return;
      if (result?.remove && typeof result.remove === 'function') removeListener = result.remove;
    } catch (_) {
      // Bridge or addListener API may differ; avoid breaking app startup
    }
    return () => {
      if (removeListener) removeListener();
    };
  }, []);

  /* Lock body scroll so fixed navbar does not move on overscroll (e.g. iOS drag-down) on any page. */
  useEffect(() => {
    document.body.classList.add('app-scroll-lock');
    return () => document.body.classList.remove('app-scroll-lock');
  }, []);

  useEffect(() => {
    startEvDriverTracker();
  }, []);

  return (
    <Suspense fallback={null}>
      <PortraitOnlyGate />
      <BackendConnectionGuard>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route path={'/scanner'} element={<ScannerPage />} />
              <Route path="/toka/:tokaId" element={<TokaRedirectPage />} />
              <Route path="/startError" element={<StartErrorPage />} />
              <Route path="*" element={<NotFoundPage />} />
              <Route path="/oauth2/redirect" element={<RedirectLogin />} />
              <Route path="/b2b" element={<B2bPage />} />
              <Route path="/b2b-tariffs" element={<B2BTariffsPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/contract" element={<TermsPage />} />
              <Route path="/b2b-contract" element={<B2BTermsPage />} />
              <Route path="/contacts" element={<ContactsPage />} />
              <Route path="/install-app" element={<InstallAppPage />} />
              <Route path="/open-app" element={<OpenAppPage />} />
              <Route element={<StationNumberLayout />}>
                <Route path="/charging" element={<ChargingPage />} />
                <Route
                  path="/start"
                  element={
                    <PrivateRoute>
                      <StartPage />
                    </PrivateRoute>
                  }
                />
              </Route>
              <Route element={<StartManyLayout />}>
                <Route path="/startMany" element={<StartManyPage />} />
              </Route>
              <Route path={'/'} element={<HomeMapPage />} />
              <Route path={'/list'} element={<HomeListPage />} />
            </Route>
          </Routes>
        </Router>
      </BackendConnectionGuard>
    </Suspense>
  );
}

export default App;
